import React, { useEffect } from 'react';
import styled from 'styled-components';
import { DynamicObjectType } from 'types/commons';
import ProductsOrder from './ProductsOrder';
import { Card, Space } from 'antd';
import OrderPriceDetail from './OrderPriceDetail';
import OrderHistories from './OrderHistories';
import { getAllOrderHistories } from '@redux/orderHistories/actions';
import { useDispatch } from '@redux';

const OrderLeftContentStyle = styled.div`
  // .order-items {
  //   padding: 0px;
  //   .ant-card-body {
  //     padding: 0px;
  //   }
  //   .ant-table-cell {
  //     background-color: transparent;
  //   }
  // }
`;

const LeftContent = ({ data }: DynamicObjectType) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (data?.id) {
      dispatch(
        getAllOrderHistories({
          data: {
            pageSize: 100,
            join: ['creator'],
            filters: [
              {
                key: 'orderId',
                condition: 'and',
                value: data?.id,
                operator: 'eq',
              },
            ],
            orderBy: '-createdAt',
          },
          options: {
            isRefresh: true,
          },
        }),
      );
    }
  }, [data]);

  return (
    <OrderLeftContentStyle>
      <Space size={20} direction="vertical" className="w-full">
        <Card title="Product information">
          <ProductsOrder
            isRejectReturn
            data={data}
            items={data?.items}
            fulfillmentInspection={data?.fulfillmentInspection}
          />
        </Card>
        <OrderPriceDetail data={data} />
        <OrderHistories />
      </Space>
      {/* <Space className="w-full mt-5" size={20} direction="vertical">
        <OrderPriceDetail data={data} />
        <OrderHistories data={data} />
      </Space> */}
    </OrderLeftContentStyle>
  );
};

export default LeftContent;
